"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const styles_1 = require("@material-ui/core/styles");
const ThemeProvider_1 = __importDefault(require("@material-ui/styles/ThemeProvider"));
const GlobalStyles_1 = __importDefault(require("../styles/GlobalStyles"));
const theme_1 = __importDefault(require("../styles/theme"));
const materialTheme = styles_1.createTheme({
    props: {
        MuiIconButton: {
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
        },
    },
    palette: {
        text: {
            primary: theme_1.default.colors.textDefault,
            secondary: theme_1.default.colors.textLight,
            disabled: theme_1.default.colors.textInactive,
            hint: theme_1.default.colors.textLight,
        },
        action: {
            disabled: theme_1.default.colors.textLight,
        },
    },
    typography: {
        fontFamily: 'Rubik, sans-serif',
    },
});
const ThemeProvider = ({ children }) => (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme_1.default },
    react_1.default.createElement(ThemeProvider_1.default, { theme: materialTheme },
        react_1.default.createElement(GlobalStyles_1.default, null),
        children)));
exports.default = ThemeProvider;
